<p-table class="order-summary-grid" [columns]="cols" [value]="samples" *ngIf="printing === printToggle.ORDERSUMMARY">
  <ng-template pTemplate="header" let-columns>
    <tr class="sample-head">
      <th *ngFor="let col of columns" class="{{col.field}}" [style.width]="((col.width) ? col.width : '')"
        [ngClass]="{'dont-print': ((col.field === 'printBarcodeSelector') || (col.field === 'total') || (col.field === 'barcode'))}">
        <span class="cell-content">{{col.header}}</span>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
    <tr class="sample-row page-break">
      <td class="dont-print" *ngIf="!isViewSchedule">
        <div class="p-input-number print-barcode-selector" [appInputNumber]="ipt"
          (update)="printBarcodeSelector($event)">
          <input id="barcode-selector-input" #ipt type="text" pInputText maxlength="3" pKeyFilter="pint" />
        </div>
      </td>
      <td class="sample-details">
        <div class="form-horizontal form-width-dynamic">
          <div class="form-group">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiSampleNamePreview' | translate}}</div>
            </div>
            <div class="form-input-div">{{rowData.customerReference}}</div>
          </div>
          <div class="form-group" *ngIf="rowData.priorityLevelDisplayName">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiPriority' | translate}}</div>
            </div>
            <div class="form-input-div">{{rowData.priorityLevelDisplayName}}</div>
          </div>
          <div class="form-group" *ngIf="rowData.description">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiDescription' | translate}}</div>
            </div>
            <div class="form-input-div">{{rowData.description}}</div>
          </div>
          <div class="form-group">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiEurofinsSampleCode' | translate}}</div>
            </div>
            <div class="form-input-div">{{rowData.eurofinsSampleCode}}</div>
          </div>
          <div class="form-group" *ngIf="isExternalLIMS && rowData.lotNumber">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiLotNumber' | translate}}</div>
            </div>
            <div class="form-input-div break-all">{{rowData.lotNumber}}</div>
          </div>
          <div class="form-group" *ngIf="rowData.comment">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiComments' | translate}}</div>
            </div>
            <div class="form-input-div">{{rowData.comment}}</div>
          </div>
          <div class="form-group" *ngIf="+rowData.servingSize > 0">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiServingSize' | translate}}</div>
            </div>
            <div class="form-input-div">
              {{rowData.servingSize}} &nbsp;
              {{rowData.servingUnitNumeratorName}}
              {{'vbeiServing' | translate}}
            </div>
          </div>
          <div class="form-group" *ngIf="hasAttachments(rowData)" [ngClass]="{'dont-print' : noClean(rowData)}">
            <div class="form-label-div">
              <span class="form-label form-label-top">
                <span>{{'vbeiSampleAttachment' | translate}}</span>
              </span>
            </div>
            <div class="form-input-div">
              <div class="files-container">
                <div class="file-container" *ngFor="let file of attachments(rowData)">
                  <div class="file-content uploaded">
                    <span class="file-icon m-r-8 m-b-auto">
                      <img [src]="file.icon" width="20" height="24" [ngClass]="{'dont-print' : !clean(file)}" />
                    </span>
                    <a class="anchor file-name dont-print" (click)="downloadAttachment(file)">{{file.name}}</a>
                    <a class="anchor file-name anchor-print print-me" *ngIf="clean(file)"
                      [href]="downloadUrl + file.internalFileName">{{file.name}}</a>
                  </div>
                  <span class="copy-link print-me" *ngIf="clean(file)" [ngClass]="{'hide-in-chrome' : isChrome}">
                    {{downloadUrl + file.internalFileName}}</span>
                </div>
              </div>
              <div class="older-doc-info" *ngIf="getArchivedFilesCount(rowData)">
                {{getArchivedFilesMessage(rowData)}}
              </div>
            </div>
          </div>
          <div *ngIf="showPrice" class="form-group print-me">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiTotal' | translate}}</div>
            </div>
            <div class="form-input-div">
              <span class="total">{{rowData.price}}</span>
            </div>
          </div>
          <div class="form-group print-me">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiBarcode' | translate}}</div>
            </div>
            <div class="form-input-div">
              <ngx-barcode class="sample-barcode" [bc-element-type]="'img'" [bc-font-size]="'25'"
                [bc-value]="rowData.eurofinsSampleCode" [bc-display-value]="true"></ngx-barcode>
            </div>
          </div>
          <div class="form-group print-me" *ngIf="rowData.product?.productCode">
            <div class="form-label-div">
              <div class="form-label">{{'vbeiAnalysisMatrix' | translate}}:</div>
            </div>
            <div class="form-input-div">{{rowData.product.productName}}</div>
          </div>
          <div>
            <app-additional-fields *ngIf="rowData.additionalFields && rowData.additionalFields.length > 0"
              [additionalFields]="rowData.additionalFields">
            </app-additional-fields>
          </div>
        </div>
      </td>
      <td class="sample-analyses" [attr.colspan]="ColSpan()">
        <div class="form-group dont-print" *ngIf="rowData.product?.productCode">
          <div class="form-label-div">
            <div class="form-label"><b>{{'vbeiAnalysisMatrix' | translate}}:</b> {{rowData.product.productName}}</div>
          </div>

        </div>
        <div class="form-horizontal form-width-dynamic" *ngFor="let analysis of rowData.analysisDisplay | orderBy: 'sequence'; let i=index">
          <div class="flex-body justify-content-between remove-flex-print">
            <div class="analysis-data" [ngClass]="{'adjust-width' : displayStructuredComment}">
              <div class="form-group" *ngIf="analysis.code">
                <div class="form-label-div">
                  <div class="form-label"><b class="no-wrap">[{{analysis.code}}]</b></div>
                </div>
                <div class="form-input-div">
                  {{analysis.displayName}}
                </div>
              </div>
              <div class="form-group" *ngIf="!analysis.code">
                <div class="form-label-div w-full">
                  {{analysis.displayName}}
                </div>
              </div>
              </div>
                <div class="word-break" *ngIf="shouldDisplayChild(analysis)">
                   - {{'vbeiPerform' | translate}} {{analysis.executionNumber}}   
                     {{ (analysis.executionNumber === 1 ? 'vbeiTimeWithSmallT' : 'vbeiTimes') | translate }}
              </div>
            <div class="structured-comment"  *ngIf="displayStructuredComment
            && (!analysis.isSubGroup && analysis.subgroupCode == null)">{{AnalysisHelper.getStructuredCommentValue(analysis)}}</div>
          </div>
          <ul>
            <li *ngFor="let child of analysis.childDisplay | orderBy: 'sequence'; let i=index">
              <ng-container class="clear-both" *ngIf="child.code || child.displayName">
                <div class="flex-body justify-content-between remove-flex-print">
                  <div class="form-group analysis-child" [ngClass]="{'adjust-width' : displayStructuredComment}">
                    <div class="form-label-div">
                      <div class="form-label"><b class="no-wrap">[{{child.code}}]</b></div>
                    </div>
                    <div class="form-input-div">{{child.displayName}}</div>
                  </div>
                    <div *ngIf="shouldDisplayChild(child)" 
                    class="word-break-child">- {{'vbeiPerform' | translate}} {{child.executionNumber}}  
                       {{ (child.executionNumber === 1 ? 'vbeiTimeWithSmallT' : 'vbeiTimes') | translate }}</div>
                  <div class="structured-comment" *ngIf="displayStructuredComment">{{AnalysisHelper.getStructuredCommentValue(child, analysis)}}</div>
                </div>
                <ul *ngIf="child.childDisplay && child.childDisplay.length > 0">
                  <li *ngFor="let innerChild of child.childDisplay | orderBy: 'sequence'; let i=index">
                    <ng-container  class="clear-both" *ngIf="innerChild.code || innerChild.displayName">
                      <div class="form-group analysis-inner-child"
                        [ngClass]="{'adjust-width' : displayStructuredComment}">
                        <div class="form-label-div">
                          <div class="form-label"><b class="no-wrap">[{{innerChild.code}}]</b></div>
                        </div>
                        <div class="form-input-div">{{innerChild.displayName}}</div>
                      </div>
                    </ng-container>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
     
        </div>
        <ng-container *ngIf="rowData.mandatoryAnalysisDisplay && rowData.mandatoryAnalysisDisplay.length>0">
            <div class="p-div-table-row flex-body justify-content-between pad-bottom remove-flex-print adjust-width-div">
                                    <div class="p-div-table-cell">
                                        <div class="package-detail flex-body align-items-center remove-flex-print">
                                            <span class="label bold m-r-12">
                                                {{'vbeiPreparationTests' |
                                                translate}}
                                            </span>
                                        </div>
                                    </div>
            </div>
          <div class="form-horizontal form-width-dynamic"  *ngFor="let analysis of rowData.mandatoryAnalysisDisplay">
              <div  class="flex-body justify-content-between remove-flex-print">
                <div class="analysis-data" [ngClass]="{'adjust-width' : displayStructuredComment}">
                  <div class="form-group" *ngIf="analysis.code">
                    <div class="form-label-div">
                      <div class="form-label"><b class="no-wrap">[{{analysis.code}}]</b></div>
                    </div>
                    <div class="form-input-div">
                      {{analysis.displayName}}
                    </div>
                  </div>
                  <div class="form-group" *ngIf="!analysis.code">
                    <div class="form-label-div w-full">
                      {{analysis.displayName}}
                    </div>
                  </div>
                </div>
                <div *ngIf="this.currentOrder.orderTemplate?.useMultipleDetermination" 
                class="word-break">- {{'vbeiPerform' | translate}} {{analysis.executionNumber}}   
                  {{ (analysis.executionNumber === 1 ? 'vbeiTimeWithSmallT' : 'vbeiTimes') | translate }}</div>

                <div class="structured-comment" *ngIf="displayStructuredComment
                && !analysis.isSubGroup">{{analysis.structuredComment?.value}}</div>
              </div>
            </div>
      </ng-container>
        <div class="specification-data" *ngIf="rowData.specifications?.length > 0">
          <div>{{'vbeiSpecifications'|translate}}</div>
          <div *ngFor="let specification of rowData.specifications; let i=index">
            <div *ngFor="let parameter of specification.parameters let i=index">
              <span class="font-bold">[{{specification.testCode}}]</span> {{specification.testName + ' - ' + parameter.parameterName + ': ' +
              parameter.standardSpecification.target}}
              {{parameter.standardSpecification.numeratorCode?.name === undefined ? '' :
              parameter.standardSpecification.numeratorCode?.name}}
              /{{parameter.standardSpecification.denominatorCode?.name === undefined ? '' :
              parameter.standardSpecification.denominatorCode?.name}}
              &nbsp;({{parameter.standardSpecification?.min === undefined ? ' ' : parameter.standardSpecification.min}}
              -{{parameter.standardSpecification?.max === undefined ? ' ' : parameter.standardSpecification.max}})
            </div>
          </div>
        </div>
      </td>
      <td class="dont-print" *ngIf="showPrice">
        <span class="total">{{rowData.price}}</span>
      </td>
      <td class="dont-print" *ngIf="!isViewSchedule">
        <ngx-barcode class="sample-barcode" [bc-element-type]="'img'" [bc-font-size]="'25'"
          [bc-value]="rowData.eurofinsSampleCode" [bc-display-value]="true"></ngx-barcode>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-table class="packing-list-grid" [columns]="packingListCols" [value]="samples"
  *ngIf="printing === printToggle.PACKINGLIST">
  <ng-template pTemplate="header" let-columns>
    <tr class="sample-head">
      <th *ngFor="let col of columns" class="{{col.field}}" width="{{(col.width) ? col.width : ''}}">
        <span class="cell-content">{{col.header}}</span>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr class="sample-row">
      <td *ngFor="let col of columns">
        <span class="break-word" *ngIf="col.field != 'barcode' && col.field != 'servingSize'">{{rowData[col.field]}}</span>
        <span class="break-word" *ngIf="col.field == 'servingSize'">{{getServingUnit(rowData)}}</span>
        <ngx-barcode *ngIf="col.field == 'barcode'" class="sample-barcode" [bc-element-type]="'img'"
          [bc-font-size]="'25'" [bc-value]="rowData.eurofinsSampleCode" [bc-display-value]="true"></ngx-barcode>
      </td>
    </tr>
  </ng-template>
</p-table>
